import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft } from "lucide-react";

const components = {
  h1: (props) => <h1 className="font-heading text-3xl md:text-4xl text-chromed mt-10 mb-4" {...props} />,
  h2: (props) => <h2 className="font-heading text-2xl md:text-3xl text-brass mt-10 mb-4 border-t border-linecol pt-8" {...props} />,
  h3: (props) => <h3 className="font-heading text-xl md:text-2xl text-chromed mt-6 mb-3" {...props} />,
  p: (props) => <p className="text-chromed/70 leading-relaxed mb-4" {...props} />,
  ul: (props) => <ul className="list-disc pl-6 text-chromed/70 mb-4 space-y-1" {...props} />,
  ol: (props) => <ol className="list-decimal pl-6 text-chromed/70 mb-4 space-y-1" {...props} />,
  li: (props) => <li className="leading-relaxed" {...props} />,
  strong: (props) => <strong className="text-chromed font-semibold" {...props} />,
  blockquote: (props) => (
    <blockquote className="border-l-2 border-brass pl-4 italic text-chromed/80 my-4" {...props} />
  ),
  hr: () => <hr className="border-linecol my-10" />,
  table: (props) => (
    <div className="overflow-x-auto mb-6">
      <table className="w-full text-sm border border-linecol" {...props} />
    </div>
  ),
  th: (props) => <th className="border border-linecol bg-iron px-3 py-2 text-left text-brass" {...props} />,
  td: (props) => <td className="border border-linecol px-3 py-2 text-chromed/70" {...props} />,
  code: (props) => <code className="bg-iron px-1.5 py-0.5 text-brass text-sm" {...props} />,
  pre: (props) => <pre className="bg-iron border border-linecol p-4 overflow-x-auto text-sm mb-4" {...props} />,
};

export const DocPage = ({ mdPath }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(mdPath)
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch(() => setContent("Gagal memuat dokumen."))
      .finally(() => setLoading(false));
  }, [mdPath]);

  return (
    <div className="min-h-screen bg-ink font-body">
      <header className="border-b border-linecol px-6 md:px-12 py-6">
        <Link
          data-testid="docpage-back-link"
          to="/"
          className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-brass hover:text-brass-light transition-colors"
        >
          <ArrowLeft size={16} /> Kembali ke Lasercut
        </Link>
      </header>
      <main data-testid="docpage-content" className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        {loading ? (
          <p className="text-chromed/50">Memuat dokumen...</p>
        ) : (
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
            {content}
          </ReactMarkdown>
        )}
      </main>
    </div>
  );
};
